/**
 * @author: subhasish.ghosh@zoom.us
 */

import React from "react";
import { Alert, AlertTitle } from "@mui/material";

const CopiedData = ({ data }) =>
  data?.length ? (
    <Alert severity="info" sx={{ width: "100%", mt: 1 }}>
      <AlertTitle sx={{ textAlign: "left" }}>Copied data:</AlertTitle>
      <div
        style={{
          textAlign: "left",
        }}
      >
        <code
          style={{
            maxHeight: 200,
            overflow: "auto",
            whiteSpace: "pre-line",
          }}
        >
          {data}
        </code>
      </div>
    </Alert>
  ) : (
    <></>
  );

export default CopiedData;
